import 'media/css/PercentCircle.scss';

interface PercentCircleProps {
  percent: number;
  size?: number;
  strokeWidth?: number;
  label?: string;
}

export default function PercentCircle({ percent, size = 64, strokeWidth = 6, label }: PercentCircleProps) {
  const safePercent = Math.min(100, Math.max(0, percent));

  return (
    <div
      className="percent-circle"
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={safePercent}
      style={
        {
          '--percent': safePercent,
          '--size': `${size}px`,
          '--stroke-width': `${strokeWidth}px`,
        } as React.CSSProperties
      }
    >
      <div className="percent-circle__content">
        <strong>{Math.round(safePercent)}%</strong>
        {label && <span className="percent-circle__label">{label}</span>}
      </div>
    </div>
  );
}

